module.exports = __webpack_public_path__ + "img/img_prize2.abce17b4.png";